import { useEffect, useRef } from 'react';

interface UseRingtoneProps {
  callStatus: 'idle' | 'dialing' | 'connected' | 'ended' | 'ringing';
  audioSrc: string;
}

const useRingtone = ({ callStatus, audioSrc }: UseRingtoneProps) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (callStatus === 'ringing') {
      // 오디오 객체 생성 및 반복 재생 설정
      if (!audioRef.current) {
        audioRef.current = new Audio(audioSrc);
        audioRef.current.loop = true;
      }

      // 재생 시작
      const playAudio = async () => {
        try {
          await audioRef.current?.play();
        } catch (error) {
          console.error('오디오 재생 오류:', error);
        }
      };

      playAudio();
    } else if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current = null;
      }
    };
  }, [callStatus, audioSrc]);

  return null;
};

export default useRingtone;
